export const postTradeReference = async (
  urlSlug: string,
  trackingId: string,
  responses: Record<string, unknown>,
): Promise<void> => {
  await fetch(`${process.env.REACT_APP_API_URL}/trade-references/${urlSlug}/${trackingId}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      responses,
    }),
  });
};
